export default "__VITE_ASSET__Cxds5vhF__"